// colorNames.js - resolves a stored color value (a human name like "black",
// or a raw hex code like "#4c4c49") to a human-readable name for display.
// There is no name field stored for hex colors anywhere in the DB, so hex
// values are matched to the nearest standard CSS color name by RGB distance.
const CSS_COLOR_NAMES = {
  noir: "#000000", "gris tres fonce": "#1a1a1a", "gris fonce": "#333333",
  "gris anthracite": "#4c4c49", "gris ardoise": "#4b4b4b", gris: "#808080",
  "gris clair": "#c0c0c0", "gris perle": "#d5cbbd", "blanc casse": "#f5f5dc",
  blanc: "#ffffff", beige: "#e8d6c3", marron: "#7a1d20", "brun rouge": "#8b0000",
  bordeaux: "#800020", rouge: "#ff0000", "rouge fonce": "#b22222",
  corail: "#ff7f50", saumon: "#ffcac8", rose: "#ffc0cb", "rose vif": "#ff69b4",
  fuchsia: "#ff00ff", magenta: "#d5006d", violet: "#8000ff", mauve: "#c8a2c8",
  indigo: "#4b0082", "bleu marine": "#000080", "bleu nuit": "#191970",
  bleu: "#4293ca", "bleu roi": "#4169e1", "bleu ciel": "#87ceeb",
  turquoise: "#40e0d0", cyan: "#00ffff", sarcelle: "#008080",
  vert: "#008000", "vert fonce": "#006400", "vert clair": "#90ee90",
  olive: "#808000", kaki: "#c3b091", jaune: "#ffff00", "jaune moutarde": "#e1ad01",
  or: "#ffd700", orange: "#ffa500", "orange fonce": "#ff8c00",
};

const hexToRgb = (hex) => {
  const clean = hex.replace("#", "");
  const full = clean.length === 3 ? clean.split("").map((c) => c + c).join("") : clean;
  const num = parseInt(full, 16);
  if (Number.isNaN(num) || full.length !== 6) return null;
  return { r: (num >> 16) & 255, g: (num >> 8) & 255, b: num & 255 };
};

const nearestColorName = (hex) => {
  const rgb = hexToRgb(hex);
  if (!rgb) return hex;
  let bestName = hex;
  let bestDistance = Infinity;
  for (const [name, candidateHex] of Object.entries(CSS_COLOR_NAMES)) {
    const candidateRgb = hexToRgb(candidateHex);
    if (!candidateRgb) continue;
    const distance =
      (rgb.r - candidateRgb.r) ** 2 +
      (rgb.g - candidateRgb.g) ** 2 +
      (rgb.b - candidateRgb.b) ** 2;
    if (distance < bestDistance) {
      bestDistance = distance;
      bestName = name;
    }
  }
  return bestName;
};

// Returns a human-readable label for a stored color value. Hex values are
// resolved to the closest known color name; anything else (already a word)
// is returned capitalized as-is.
export const getColorDisplayName = (colorValue) => {
  if (!colorValue) return colorValue;
  if (colorValue.startsWith("#")) {
    const name = nearestColorName(colorValue);
    return name.startsWith("#") ? name : name.charAt(0).toUpperCase() + name.slice(1);
  }
  return colorValue.charAt(0).toUpperCase() + colorValue.slice(1);
};
